import React, { useState, useEffect } from 'react';
import { BaseCard } from '../UI/BaseCard';
import { BaseSelect } from '../UI/BaseSelect';
import { BaseButton } from '../UI/BaseButton';
import { BasePetSelector } from '../UI/BasePetSelector';
import { IconDogGeneral } from '../Icons/IconDogGeneral';
import { IconCatGeneral } from '../Icons/IconCatGeneral';
import { __, sprintf } from '@wordpress/i18n';

import { foodInfo, foodListByPet, foodCheckerStateByCategory } from '../../utils/food';

import { useForm } from '../../hooks/useForm';
import { requiredFieldValidator } from '../../utils/validation';

export const CalculatorFoodChecker = () => {
  const [result, setResult] = useState(null);

  const petTypes = [
    {
      value: 'dog',
      icon: <IconDogGeneral />
    },
    {
      value: 'cat',
      icon: <IconCatGeneral />
    }
  ];

  const { formValue, formErrors, setFormFieldValue, setFormValue, onFormSubmit } = useForm({
    form: {
      petType: 'dog',
      searchText: ''
    },
    rules: {
      searchText: [requiredFieldValidator()]
    },
    onSubmit: () => {
      getCalculatorResult(formValue);
    }
  });

  useEffect(() => {
    setResult(null);
  }, [formValue]);

  const lang = document.querySelector('body').classList.contains('en') ? 'en' : 'nl';

  const getCalculatorResult = ({ petType, searchText }) => {
    const result = foodInfo[petType].find((item) => {
      return item.food[lang].toLowerCase().split(', ').includes(searchText.toLowerCase()) || item.emoji === searchText;
    });

    if (result) {
      setResult({
        title: foodCheckerStateByCategory[result.category].title[lang],
        answer: result.answer[lang],
        status: foodCheckerStateByCategory[result.category].status
      });
    } else {
      setResult({
        title: foodCheckerStateByCategory['NOT_FOUND'].title[lang],
        status: foodCheckerStateByCategory['NOT_FOUND'].status
      });
    }
  };

  const foodList = foodListByPet(formValue.petType, lang);

  const onSelectPetType = (petType) => {
    setFormValue({
      ...formValue,
      petType,
      searchText: ''
    });
    setResult(null);
  };

  return (
    <div className="calculator calculator--food-checker">
      <BaseCard title={__('Pet Food Checker', 'cooperpetcare')}>
        <BasePetSelector items={petTypes} value={formValue.petType} size="small" onSelect={onSelectPetType} />

        <BaseSelect
          className="field persistent-placeholder"
          label={__('Is it okay for my pet to eat this?', 'cooperpetcare')}
          placeholder={__('Type a food here 🍐🍓🍕', 'cooperpetcare')}
          persistentPlaceholder={true}
          isInvalid={!!formErrors.searchText}
          hint={formErrors.searchText}
          value={formValue.searchText}
          options={foodList}
          filterField="filterList"
          onSelect={setFormFieldValue('searchText')}
        ></BaseSelect>

        <BaseButton className="btn-rounded" variant="success" onClick={onFormSubmit}>
          {__('Search', 'cooperpetcare')}
        </BaseButton>

        {result && (
          <div className={`result food-checker result-${result.status}`}>
            <h3 className="result-title">{result.title}</h3>
            {result.answer && <div className="result-description" dangerouslySetInnerHTML={{ __html: result.answer }} />}
          </div>
        )}
      </BaseCard>
    </div>
  );
};
